/**
 * Deployment environment detection utilities
 *
 * This module provides centralized detection of the deployment environment
 * to conditionally enable/disable developer features.
 *
 * Environment mapping:
 * - main branch (VAgentUIStack): development
 * - feat/* branches (VAgentUIPreview-*): development
 * - prod-* branches (VAgentUIProdStack): production
 */

export type DeployEnv = "development" | "production";

/**
 * Get the current deployment environment.
 * Defaults to "production" if not set (safer for accidental prod deploys).
 */
export function getDeployEnv(): DeployEnv {
  const env = process.env.NEXT_PUBLIC_DEPLOY_ENV;
  if (env === "development") {
    return "development";
  }
  // Default to production for safety
  return "production";
}

/**
 * Check if running in production deployment mode.
 * Production mode hides developer features (backend selector, verbose logs).
 */
export function isProductionDeploy(): boolean {
  return getDeployEnv() === "production";
}

/**
 * Check if running in development deployment mode.
 * Development mode shows all developer features.
 */
export function isDevelopmentDeploy(): boolean {
  return getDeployEnv() === "development";
}
